import React, { ReactNode } from 'react';

type LayoutProps = {
  children: ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className={`h-screen w-screen`}>
      <img src="/Others/LoginBackground.png" alt="background" className={`bg-cover w-screen absolute z-0 bottom-0 left-0 right-0 top-0`}/>
      <header>
      </header>
      <main>{children}</main>
      <footer>
      </footer>
    </div>
  );
};

export default Layout;
